/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEnum } from './RoleEnum';
import {
    RoleEnumFromJSON,
    RoleEnumFromJSONTyped,
    RoleEnumToJSON,
    RoleEnumToJSONTyped,
} from './RoleEnum';

/**
 *
 * @export
 * @interface InvitationWrite
 */
export interface InvitationWrite {
    /**
     *
     * @type {number}
     * @memberof InvitationWrite
     */
    team: number;
    /**
     *
     * @type {string}
     * @memberof InvitationWrite
     */
    email: string;
    /**
     *
     * @type {RoleEnum}
     * @memberof InvitationWrite
     */
    role?: RoleEnum;
}



/**
 * Check if a given object implements the InvitationWrite interface.
 */
export function instanceOfInvitationWrite(value: object): value is InvitationWrite {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function InvitationWriteFromJSON(json: any): InvitationWrite {
    return InvitationWriteFromJSONTyped(json, false);
}

export function InvitationWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationWrite {
    if (json == null) {
        return json;
    }
    return {

        'team': json['team'],
        'email': json['email'],
        'role': json['role'] == null ? undefined : RoleEnumFromJSON(json['role']),
    };
}

  export function InvitationWriteToJSON(json: any): InvitationWrite {
      return InvitationWriteToJSONTyped(json, false);
  }

  export function InvitationWriteToJSONTyped(value?: InvitationWrite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'team': value['team'],
        'email': value['email'],
        'role': RoleEnumToJSON(value['role']),
    };
}
